import { Directive, inject, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[siatTableCell]',
   
})
export class TableCellDirective {
  @Input('siatTableCell') forColumn: string;

  templateRef = inject(TemplateRef);
}
